<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st11"
      :custom="{storage: true}"
      export
      :refresh="{query:creditTable}"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter()">
          查询
        </el-button>
        <el-button @click="funcAdd">
          新增
        </el-button>
        <!--        <el-button v-if="loginkTarget != 0" @click="getSelectEvent()">批量上报</el-button>-->
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="creditTable"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
    >
      <vxe-table-column
        type="checkbox"
        width="70"
      />
      <vxe-table-column>
        <vxe-table-column
          field="reportTime"
          title="数据时间"
          min-width="420"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.payTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'reportTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="carrierCreditCount"
          title="信用查询次数-实际承运人"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.carrierCreditCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'carrierCreditCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.carrierCreditCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'carrierCreditCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleCreditCount"
          title="信用查询次数-车辆"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.vehicleCreditCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'vehicleCreditCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.vehicleCreditCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'vehicleCreditCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverCreditCount"
          title="信用查询次数-驾驶员"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverCreditCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'driverCreditCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.driverCreditCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'driverCreditCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="insuranceCount"
          title="发生赔付次数"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.insuranceCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'insuranceCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.insuranceCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'insuranceCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="insuranceClaimCount"
          title="完成赔付次数"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.insuranceClaimCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'insuranceClaimCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.insuranceClaimCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'insuranceClaimCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="insuranceFnishedAmount"
          title="完成赔付金额"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.insuranceFnishedAmountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'insuranceFnishedAmountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.insuranceFnishedAmountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'insuranceFnishedAmountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="transportAccidentCount"
          title="运输生产安全事故-发生次数"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.transportAccidentCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'transportAccidentCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.transportAccidentCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'transportAccidentCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="transportAccidentFinishedCount"
          title="运输生产安全事故-完成处理次数"
          min-width="240"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.transportAccidentFinishedCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'transportAccidentFinishedCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.transportAccidentFinishedCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'transportAccidentFinishedCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="serviceProblemCount"
          title="服务质量投诉-发生次数"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.serviceProblemCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'serviceProblemCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.serviceProblemCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'serviceProblemCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="serviceProblemHandleCount"
          title="服务质量投诉-完成处理次数"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.serviceProblemHandleCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'serviceProblemHandleCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.serviceProblemHandleCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'serviceProblemHandleCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="billingQualification"
          title="是否具备增值税开票资格"
          :formatter="formatterBillingStatus"
          min-width="240"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.billingQualification"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in sendOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="billingCount"
          title="开票数"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.billingCountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'billingCountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.billingCountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isInteger(value,oldValue,listQuery,'billingCountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="billingAmount"
          title="开票金额"
          min-width="200"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.dbillingAmountStart"
                placeholder="开始"
                clearable
                @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'dbillingAmountStart')"
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.dbillingAmountEnd"
                placeholder="结束"
                clearable
                @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'dbillingAmountEnd')"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSend"
          title="上报状态"
          :formatter="formatterSendFundStatus"
          min-width="200"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSend"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in sendFundOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        title="操作"
        min-width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.isSend != 1 && loginkTarget != 0"
            class="item"
            effect="dark"
            content="上报"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="orderopen(scope.row.code)"
            >
              <i class="el-icon-upload" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.isSend != 1"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code)"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.isSend != 1"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDelete(scope.row.code)"
            >
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="860"
      height="600"
      resize
    >
      <compAdd
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="860"
      height="600"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
  </div>
</template>

<script>
import request from "@/utils/request";
import { reportCreditQuality } from "@/api/transport";
import compAdd from "./components/compAdd";
import compEdit from "./components/compEdit";
export default {
  components: {
    compAdd,
    compEdit,
  },
  data() {
    return {

      creditTable: [],
      //容器
      creditArry: {},
      Pagingconf: [],
      listQuery: {
        payTimeRange: "",
        code: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        status: 5,
        isSendFund: "",
        isSendbillingQualification: "",
        fundErrMsg: "",
        isReportPage: 1, // 上报页面查询需传1
        reportTimeStart: "", //信用数据月份时间（开始）
        reportTimeEnd: "",
        carrierCreditCountStart: "", //信用数据查询次数（次）-实际承运人（开始）
        carrierCreditCountEnd: "",
        vehicleCreditCountStart: "", //信用数据查询次数（次）-车辆（开始）
        vehicleCreditCountEnd: "",
        driverCreditCountStart: "", //信用数据查询次数（次）-驾驶员（开始）
        driverCreditCountEnd: "",
        insuranceCountStart: "", //保险赔付-发生赔付次数（开始）
        insuranceCountEnd: "",
        insuranceClaimCountStart: "", //保险赔付-完成赔付次数（次）（开始）
        insuranceClaimCountEnd: "",
        insuranceFnishedAmountStart: "", //保险赔付-完成赔付金额（元）（开始）
        insuranceFnishedAmountEnd: "",
        transportAccidentCountStart: "", //运输生产安全事故-发生次数（次）（开始）
        transportAccidentCountEnd: "",
        transportAccidentFinishedCountStart: "", //运输生产安全事故-完成处理次数（次）（开始）
        transportAccidentFinishedCountEnd: "",
        serviceProblemCountStart: "", //服务质量投诉-发生次数（次）（开始)
        serviceProblemCountEnd: "",
        serviceProblemHandleCountStart: "", //服务质量投诉-完成处理次数（次）（开始）
        serviceProblemHandleCountEnd: "",
        billingQualification: "", //营改增-是否具备增值税开票资格0表示无，1表示有
        billingCountStart: "", //营改增-开票数（份）（开始）
        billingCountEnd: "",
        billingAmountStart: "", //营改增-开票金额（元）（开始）
        billingAmountEnd: "",
        branchCode: "", //机构code
        isSend: "", //是否上报
        sendError: "",
        gmtCreatedStart: "", //创建时间起始
        gmtCreatedEnd: "",
        sortField: "",
        sortType: "",
      },
      loading: false,
      modelAddFlag: false,
      modelEditFlag: false,
      loginkTarget: 0,
      sendFundOptions: [
        {
          value: "0",
          label: "未上报",
        },
        {
          value: "1",
          label: "已上报",
        },
        {
          value: "2",
          label: "上报失败",
        },
      ],
      sendOptions: [
        {
          value: "0",
          label: "无",
        },
        {
          value: "1",
          label: "有",
        },
      ],
    };
  },
  created() {
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.loginkTarget =
      dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue:0;
    this.findList();
    // this.getCreditQuality();
  },
  methods: {
    // 查询方法
    findList() {
      this.loading = true;
      return new Promise((resolve) => {
        request({
          url: "/ntocc-basic-api/creditQuality",
          method: "get",
          params: this.listQuery,
        }).then((response) => {
          this.creditTable = response.data.records;
          response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    //初始化质量信息
    // getCreditQuality() {
    //   return request({
    //     url: `/ntocc-basic-api/creditQuality`,
    //     method: "get",
    //   }).then((response) => {
    //     if (response.data) {
    //       this.creditArry = response.data.records;
    //     }
    //   });
    // },
    // 获取质量信息
    findCreditQuality() {
      this.loading = true;
      return new Promise((resolve) => {
        request({
          url: "/ntocc-basic-api/creditQuality",
          method: "get",
          params: this.creditArry.code,
        }).then((response) => {
          this.creditTable = response.data.records;
          this.loading = false;
          resolve();
        });
      });
    },
    // 添加方法
    funcAdd() {
      this.modelAddFlag = true;
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findCreditQuality();
    },
    // 删除方法/
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then((_) => {
          request({
            url: `/ntocc-basic-api/creditQuality`,
            method: "delete",
            params: { codes: row },
          }).then((response) => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch((_) => {});
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findCreditQuality();
    },
    // 修改方法
    funcEdit(code) {
      // this.creditArry = row;
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 上报
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择运单", type: "warning" });
      } else {
        const codes = selectRecords.map((item) => item.code).join(",");
        this.$confirm("确认上报监管平台吗？").then((_) => {
          const rLoading = this.openLoading();
          reportCreditQuality({ codes })
            .then((response) => {
              this.$message({ message: response.msg, type: "success" });
            })
            .finally(() => {
              this.$refs.xTable.clearCheckboxRow();
              this.findList();
              rLoading.close();
            });
        });
      }
    },
    orderopen(c) {
      this.$confirm("请确认是否要发送资金流水到 网络货运监测平台？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const rLoading = this.openLoading();
          const code = c;
          reportCreditQuality({ code })
            .then((response) => {
              this.$message({
                type: "success",
                message: response.msg,
              });
              rLoading.close();
            })
            .finally(() => {
              this.$refs.xTable.clearCheckboxRow();
              this.findList();
              rLoading.close();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    },
    // orderDesil(c) {
    //   this.$refs.detailRef.Getdetails(c);
    //   this.tuteship = true;
    // },
    formatterSendFundStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未上报";
        case 1:
          return "已上报";
        case 2:
          return "上报失败";
        default:
          break;
      }
    },
    //营增改
    formatterBillingStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "无";
        case 1:
          return "有";
        default:
          break;
      }
    },
    //公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
  },
};
</script>

<style>
</style>
